var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "the_current_user_avatar",
    on: {
      "dblclick": _vm.navigateToUserManagePage
    }
  }, [_c('c-menu', {
    attrs: {
      "nudge-top": "0px",
      "align-right": "",
      "border-color": "var(--cosmic-text)",
      "border-size": "1px"
    }
  }, [_c('div', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm.initials ? _c('ButtonMiniAction', {
    staticClass: "avatar_button",
    attrs: {
      "slot": "activator",
      "aria-label": "toggle user menu",
      "aria-selected": "false",
      "disable-scale-on-hover": "",
      "tooltip-position": "bottom right",
      "tooltip": "Toggle User menu"
    },
    slot: "activator"
  }, [_vm._v(" " + _vm._s(_vm.initials) + " ")]) : _c('ButtonMiniAction', {
    staticClass: "avatar_button",
    attrs: {
      "slot": "activator",
      "icon": _vm.randomIcon,
      "aria-label": "toggle user menu",
      "aria-selected": "false",
      "icon-color": "white",
      "tooltip-position": "bottom right",
      "tooltip": "Toggle User menu"
    },
    slot: "activator"
  })], 1), _vm.currentUserManageUrl ? _c('c-menu-item', {
    attrs: {
      "href": _vm.currentUserManageUrl
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons.MANAGE_PAGE,
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Manage my info "), _c('small', [_vm._v("View/update your personal information")])])], 1)]) : _vm._e(), _c('c-menu-item', {
    attrs: {
      "href": _vm.cosmicSupportTicketTrackerRoute
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons.support_ticket,
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Support ticket tracker "), _c('small', [_vm._v("View tickets you opened")])])], 1)]), _vm.showMyApprovalQueueLink ? _c('c-menu-item', {
    attrs: {
      "href": _vm.myApprovalQueueRoute
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": _vm.$icons.application_reporting,
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" My approval queue "), _c('small', [_vm._v("View your upcoming and past approvals")])])], 1)]) : _vm._e(), _vm._t("current_user_menu_items"), _c('hr', {
    staticClass: "my-2"
  }), _c('c-menu-item', {
    on: {
      "c-click": _vm.onClickOfClearCache
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": "fa-duotone fa-solid fa-dumpster-fire",
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Reset browser cache "), _c('small', [_vm._v("Clear your cache for a fresh start")])])], 1)]), _c('c-menu-item', {
    on: {
      "c-click": _vm.logCurrentUserOut
    }
  }, [_c('div', {
    staticClass: "c-flex align-items-center no-gap"
  }, [_c('c-icon-fa', {
    staticClass: "mr-2",
    attrs: {
      "icon-size": "22px",
      "icon": "fa-duotone fa-solid fa-right-from-bracket",
      "icon-color": "var(--cosmic-text)"
    }
  }), _c('div', {
    staticClass: "c-flex column no-gap"
  }, [_vm._v(" Logout "), _c('small', [_vm._v("Disconnect from COSMIC")])])], 1)])], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };